module.exports = __webpack_public_path__ + "static/media/expired.cf1ae2e5.svg";